interface RadioIconProps {
  width?: number;
  height?: number;
  color?: string;
}

export function RadioCheckedIcon({ width = 22, height = 22 }: RadioIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1.5C14.9477 1.5 19 5.55228 19 10.5C19 15.4477 14.9477 19.5 10 19.5C5.05228 19.5 1 15.4477 1 10.5C1 5.55228 5.05228 1.5 10 1.5Z"
        stroke="#4F55FD"
        strokeWidth="2"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 5.5C7.25 5.5 5 7.75 5 10.5C5 13.25 7.25 15.5 10 15.5C12.75 15.5 15 13.25 15 10.5C15 7.75 12.75 5.5 10 5.5Z"
        fill="#4F55FD"
      />
    </svg>
  );
}

export function RadioUncheckedIcon({ width = 22, height = 22 }: RadioIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 1C15.2239 1 19.5 5.27614 19.5 10.5C19.5 15.7239 15.2239 20 10 20C4.77614 20 0.5 15.7239 0.5 10.5C0.5 5.27614 4.77614 1 10 1Z"
        stroke="#91A2BB"
        strokeLinecap="square"
      />
    </svg>
  );
}
